module.exports = __webpack_public_path__ + "static/man-2-76c2f1cc2da3b3edc90d8ccd61bbe3dc.jpg";